@let commonData = commonDataService.getData() | async; @let phone = commonData?.phone ?? '';
@let clientBalanceAmount =
  (authorizedDataService.getAuthorizedData() | async)?.clientBalanceAmount || 0;

<div class="d-flex align-items-center justify-content-between header">
  <div class="d-flex align-items-center header__brand">
    <a *ngIf="user$ | async as user; else logo" [routerLink]="['']" class="logo-link">
      <ng-container *ngTemplateOutlet="logo" />
    </a>

    <ng-template #logo>
      <img
        src="assets/images/{{ commonData?.headerImg }}"
        [alt]="commonData?.headerAlt"
        [width]="commonData?.headerImgWidth"
        [height]="commonData?.headerImgHeight"
      />
    </ng-template>
  </div>

  <div class="d-flex align-items-center header__actions">
    @if (user$ | async) {
      @if (referralProgram$ | async; as referralProgram) {
        @if (referralProgram.isEligible) {
          <a
            [routerLink]="['/', PortalRoutes.Referrals]"
            class="header-referral-pill"
            data-id="header-referral-pill"
          >
            Earn {{ referralProgram.rewardAmount | portalCurrency: true }} for each friend
          </a>
        }
      }
    }

    <ds-button
      *ngIf="showPhone"
      [href]="'tel:' + (salesAgent?.phone || phone)"
      variant="secondary"
      leadingIcon="phone"
      [label]="salesAgent?.phone || phone | phone"
      class="d-none d-md-flex"
    />

    <div
      *ngIf="salesAgent"
      (click)="toggleDetails(detailsTemplate)"
      class="ml-5 d-flex align-items-center cursor-pointer agent"
      data-id="agent"
    >
      <div class="d-flex flex-column align-items-end">
        <p data-id="sales-agent-fullname">{{ salesAgent.fullName }}</p>

        <p class="caption text-jazlyn-700">Your travel expert</p>
      </div>

      <img [src]="salesAgent.picture" alt="agent" class="ml-2 picture" />

      <ds-card
        *ngIf="showedDetails"
        (clickOutside)="showedDetails = false"
        class="d-flex flex-column align-items-center p-6 details cursor-default"
      >
        <img [src]="salesAgent.picture" alt="agent" class="details-picture" />

        <h3 class="semi-bold mt-4" data-id="sales-agent-fullname">{{ salesAgent.fullName }}</h3>

        <p *ngIf="salesAgent.shift" class="mt-1">
          {{ salesAgent.shift.startDateTimeAtUtc | date: 'shortTime' }} –
          {{ salesAgent.shift.endDateTimeAtUtc | date: 'shortTime' }}
        </p>

        <div class="d-flex mt-2">
          <img src="assets/icons/phone.svg" width="20" height="20" alt="phone" class="mr-1" />
          <a href="tel:{{ salesAgent.phone }}" class="link">
            <p class="text-lightblue-600" data-id="sales-agent-phone">
              {{ salesAgent.phone | phone }}
            </p>
          </a>
        </div>

        <div class="d-flex mt-2">
          <img src="assets/icons/mail.svg" width="20" height="20" alt="mail" class="mr-1" />
          <a href="mailto:{{ salesAgent.email }}" class="link">
            <p class="text-lightblue-600 nowrap" data-id="sales-agent-email">
              {{ salesAgent.email }}
            </p>
          </a>
        </div>
      </ds-card>
    </div>

    <ng-template #clientBalanceTemplate>
      Wallet balance:
      <span [innerHTML]="clientBalanceAmount | portalCurrency" data-id="balance"></span>
    </ng-template>

    <div
      *ngIf="user$ | async as user; else loginTemplate"
      (click)="toggleUser(userTemplate)"
      class="ml-3 ml-md-6 cursor-pointer d-flex align-items-center user"
    >
      <div class="divider"></div>

      <img src="assets/icons/menu.svg" width="20" height="20" alt="menu" class="d-md-none" />

      <img
        [src]="user.picture || 'assets/icons/avatar.svg'"
        alt="user"
        class="d-none d-md-flex picture"
      />

      <div class="d-none d-md-flex flex-column ml-3">
        <p class="semi-bold" data-id="user-fullname">{{ user.fullname }}</p>
        <p class="caption">
          <ng-container *ngTemplateOutlet="clientBalanceTemplate" />
        </p>
      </div>

      <ng-template #userTemplate>
        <div class="d-flex flex-column cursor-default">
          <div class="p-4 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <img
                [src]="user.picture || 'assets/icons/avatar.svg'"
                alt="user"
                class="popup-picture"
              />

              <div class="d-flex flex-column ml-3">
                <p class="semi-bold" data-id="user-fullname">{{ user.fullname }}</p>
                <p class="mt-1 text-jazlyn-700" data-id="user-email">{{ user.email }}</p>
              </div>
            </div>
          </div>

          <div class="p-4 d-flex d-md-none align-items-center">
            <img
              src="assets/icons/account_balance_wallet_line.svg"
              width="20"
              height="20"
              alt="account_balance_wallet_line"
            />

            <p class="ml-2">
              <ng-container *ngTemplateOutlet="clientBalanceTemplate" />
            </p>
          </div>

          <div class="px-4 d-flex d-md-none">
            <hr />
          </div>

          <div
            (click)="showedUser = false; goToTrips()"
            class="p-4 d-flex align-items-center cursor-pointer"
            data-id="trips"
          >
            <img src="assets/icons/luggage.svg" alt="" width="20" height="20" />
            <p class="ml-2">Trips</p>
          </div>

          <div class="px-4">
            <hr />
          </div>

          <div
            (click)="showedUser = false; goToTravelers()"
            class="p-4 d-flex align-items-center cursor-pointer"
            data-id="travelers"
          >
            <img src="assets/icons/edit.svg" alt="edit" />
            <p class="ml-2">Travelers</p>
          </div>

          @if ((referralProgram$ | async)?.hasAccess) {
            <div class="px-4">
              <hr />
            </div>

            <div
              (click)="goToReferrals()"
              class="p-4 d-flex align-items-center cursor-pointer"
              data-id="referrals"
            >
              <img src="assets/icons/person_badge_plus.svg" alt="" width="20" height="20" />
              <p class="ml-2">Referrals</p>
            </div>
          }

          <div class="px-4">
            <hr />
          </div>

          <div
            (click)="showedUser = false; signOut()"
            class="p-4 d-flex align-items-center cursor-pointer"
          >
            <img src="assets/icons/logout.svg" alt="logout" />
            <p class="ml-2 text-red-700">Logout</p>
          </div>
        </div>
      </ng-template>

      <ds-card *ngIf="showedUser" (clickOutside)="showedUser = false" class="user-details">
        <ng-container *ngTemplateOutlet="userTemplate" />
      </ds-card>
    </div>

    <ng-template #loginTemplate>
      <ng-container *ngIf="showLoginButton">
        <ds-button (click)="showSignInModal()" label="Sign in" class="d-none d-md-flex ml-5" />

        <img
          (click)="showSignInModal()"
          src="assets/icons/menu.svg"
          width="20"
          height="20"
          alt="menu"
          class="ml-5 d-md-none"
        />
      </ng-container>
    </ng-template>
  </div>
</div>

<ng-template #detailsTemplate>
  <div
    *ngIf="salesAgent"
    (touchstart)="$event.stopPropagation()"
    class="d-flex justify-content-between p-4"
  >
    <div class="d-flex align-items-center">
      <img [src]="salesAgent.picture" alt="agent" class="picture" />

      <div class="d-flex flex-column ml-3">
        <h3 class="semi-bold" data-id="sales-agent-fullname">{{ salesAgent.fullName }}</h3>

        <p *ngIf="salesAgent.shift">
          {{ salesAgent.shift.startDateTimeAtUtc | date: 'shortTime' }} –
          {{ salesAgent.shift.endDateTimeAtUtc | date: 'shortTime' }}
        </p>
      </div>
    </div>

    <div class="d-flex">
      <ds-button
        size="s"
        variant="secondary"
        leadingIcon="phone"
        [href]="'tel:' + salesAgent.phone"
        label=" "
        aria-label="Call"
        class="icon-button"
      />

      <ds-button
        size="s"
        variant="secondary"
        leadingIcon="envelope"
        [href]="'mailto:' + salesAgent.email"
        label=" "
        aria-label="Email"
        class="icon-button ml-2"
      />
    </div>
  </div>
</ng-template>
